"use client";

import dynamic from "next/dynamic";
import lottieData from "@/assets/lottie/loading.json";

const Lottie = dynamic(() => import("lottie-react"), {
  ssr: false,
  loading: () => null,
});

const MainLoading = () => {
  return <Lottie animationData={lottieData} loop autoPlay />;
};

export default MainLoading;
